/** Apague e faça como quiser */